const setSession = (key: string, value: string) => {
  sessionStorage.setItem(key, value);
};

const getSession = (key: string) => sessionStorage.getItem(key);

export { getSession, setSession };
